import { createSlice } from "@reduxjs/toolkit";

const virtualNumberSlice = createSlice({
  name: "virtualNumbers",
  initialState: {
    services: null,
    activations: null,
    currentActivation: null,
    activeCount: 0,
  },
  reducers: {
    setServices(state, action) {
      state.services = action.payload;
    },
    setActivations(state, action) {
      state.activations = action.payload;
    },
    setCurrentActivation(state, action) {
      state.currentActivation = action.payload;
    },
    setActiveCount(state, action) {
      state.activeCount = action.payload;
    },
  },
});

export const {
  setServices,
  setActivations,
  setCurrentActivation,
  setActiveCount,
} = virtualNumberSlice.actions;

export default virtualNumberSlice.reducer;
